export const SET_PS_CREDITS = "SET_PS_CREDITS";
export const SET_PS_TOTALFP = "SET_PS_TOTALFP";
export const SET_PS_TOTALFP_L4 = "SET_PS_TOTALFP_L4";
export const SET_PS_SELL_BY = "SET_PS_SELL_BY";
export const SET_PS_PPG_YEAR = "SET_PS_PPG_YEAR";
export const SET_PS_PPG_L4 = "SET_PS_PPG_L4";
export const SET_PS_GPP = "SET_PS_GPP";
export const SET_PS_H2H = "SET_PS_H2H";
export const SET_PS_PROJ_VAL = "SET_PS_PROJ_VAL";
export const SET_PS_VAL_YEAR = "SET_PS_VAL_YEAR";
export const SET_PS_VAL_L4 = "SET_PS_VAL_L4";
export const SET_PS_CEIL = "SET_PS_CEIL";
export const SET_PS_FLOOR = "SET_PS_FLOOR";
export const SET_PS_CAP = "SET_PS_CAP";
export const SET_PS_VCAP = "SET_PS_VCAP";
export const SET_PS_DTA = "SET_PS_DTA";
export const SET_PS_TFPR = "SET_PS_TFPR";
export const SET_PS_TFPR_L4 = "SET_PS_TFPR_L4";
export const SET_PS_AFPR = "SET_PS_AFPR";
export const SET_PS_AFPR_L4 = "SET_PS_AFPR_L4";
export const SET_PS_TFP = "SET_PS_TFP";
export const SET_PS_TFP_L4 = "SET_PS_TFP_L4";
export const SET_PS_AFP = "SET_PS_AFP";
export const SET_PS_AFP_L4 = "SET_PS_AFP_L4";
export const SET_PS_PROJ_FP = "SET_PS_PROJ_FP";
export const SET_PS_M_COUNT = "SET_PS_M_COUNT";
export const SET_PS_DT_COUNT = "SET_PS_DT_COUNT";
export const SET_PS_CAP_COUNT = "SET_PS_CAP_COUNT";
export const SET_PS_VCAP_COUNT = "SET_PS_VCAP_COUNT";
